/**
 * Payment & pricing constants
 * Uses Solana (SOL) for crypto display; NOWPayments handles conversion
 */

/** Currency for NOWPayments (fiat price) */
export const PRICE_CURRENCY = 'usd' as const;

/** Payment crypto - Solana native token */
export const PAY_CRYPTO = 'sol' as const;

/** Display label for payment crypto */
export const PAY_CRYPTO_LABEL = 'SOL';

/** Messages per unit rate (for custom amount) - 1 USD ≈ this many messages at base rate */
export const MESSAGES_PER_USD = 100;

/** Base: $0.01 = 1 message (low rate) */
export const USD_PER_MESSAGE = 0.01;

export interface MessagePackage {
  id: string;
  messages: number;
  priceUsd: number;
  popular?: boolean;
  bonus?: string;
}

/** Pre-defined message packages - low rates */
export const MESSAGE_PACKAGES: MessagePackage[] = [
  { id: 'pack_10', messages: 10, priceUsd: 0.10, popular: false },
  { id: 'pack_60', messages: 60, priceUsd: 0.50, popular: true, bonus: '+10 bonus' },
  { id: 'pack_150', messages: 150, priceUsd: 1.0, popular: false, bonus: '+50 bonus' },
];

/** Minimum messages for custom amount */
export const MIN_MESSAGES = 10;

/** Maximum messages for custom amount */
export const MAX_MESSAGES = 1000;

/** Get price in USD for a given message count (simple linear) */
export function getPriceUsd(messages: number): number {
  return Math.round(messages * USD_PER_MESSAGE * 100) / 100;
}
